export var ConversationStateVoData;
(function (ConversationStateVoData) {
    ConversationStateVoData["NOT_SEND"] = "notSend";
    ConversationStateVoData["SEND"] = "send";
    ConversationStateVoData["SENDED"] = "sended";
})(ConversationStateVoData || (ConversationStateVoData = {}));
//# sourceMappingURL=conversation-state-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/chat/conversation-state-vo-data.js
// module id = 394
// module chunks = 14